export const usersTranslations = {
  ar: {
    title: 'المستخدمين',
    addNew: 'إضافة جديد',
    name: 'الاسم',
    userName: 'اسم المستخدم',
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    email: 'البريد الإلكتروني',
    phoneNumber: 'رقم الهاتف',
    mobileNumber: 'رقم الجوال',
    companyCode: 'رمز الشركة',
    branchCode: 'رمز الفرع',
    password: 'كلمة المرور',
    expiryDate: 'تاريخ الانتهاء',
    serial: 'التسلسل',
    fullName: 'الاسم الكامل',
    branch: 'الفرع',
    noUsers: 'لا يوجد مستخدمين',
    loading: 'جاري تحميل المستخدمين...',
    error: 'فشل تحميل المستخدمين',
    saveSuccess: 'تم حفظ المستخدم بنجاح',
    saveError: 'فشل حفظ المستخدم',
    deleteSuccess: 'تم حذف المستخدم بنجاح',
    deleteError: 'فشل حذف المستخدم',
    copySuccess: 'تم نسخ المستخدم',
    pasteSuccess: 'تم لصق المستخدم بنجاح',
    pasteError: 'لا يوجد مستخدم منسوخ',
    isActive: 'نشط',
    inactive: 'غير نشط',
    list: 'قائمة',
  },
  en: {
    title: 'Users',
    addNew: 'Add New',
    name: 'Name',
    userName: 'Username',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    mobileNumber: 'Mobile Number',
    companyCode: 'Company Code',
    branchCode: 'Branch Code',
    password: 'Password',
    expiryDate: 'Expiry Date',
    serial: 'Serial',
    fullName: 'Full Name',
    branch: 'Branch',
    noUsers: 'No users',
    loading: 'Loading users...',
    error: 'Failed to load users',
    saveSuccess: 'User saved successfully',
    saveError: 'Failed to save user',
    deleteSuccess: 'User deleted successfully',
    deleteError: 'Failed to delete user',
    copySuccess: 'User copied',
    pasteSuccess: 'User pasted successfully',
    pasteError: 'No user copied',
    isActive: 'Active',
    inactive: 'Inactive',
    list: 'List',
  },
  fr: {
    title: 'Utilisateurs',
    addNew: 'Ajouter nouveau',
    name: 'Nom',
    userName: 'Nom d\'utilisateur',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    email: 'Email',
    phoneNumber: 'Numéro de téléphone',
    mobileNumber: 'Numéro de mobile',
    companyCode: 'Code entreprise',
    branchCode: 'Code succursale',
    password: 'Mot de passe',
    expiryDate: 'Date d\'expiration',
    serial: 'Série',
    fullName: 'Nom complet',
    branch: 'Succursale',
    noUsers: 'Aucun utilisateur',
    loading: 'Chargement des utilisateurs...',
    error: 'Échec du chargement des utilisateurs',
    saveSuccess: 'Utilisateur enregistré avec succès',
    saveError: 'Échec de l\'enregistrement de l\'utilisateur',
    deleteSuccess: 'Utilisateur supprimé avec succès',
    deleteError: 'Échec de la suppression de l\'utilisateur',
    copySuccess: 'Utilisateur copié',
    pasteSuccess: 'Utilisateur collé avec succès',
    pasteError: 'Aucun utilisateur copié',
    isActive: 'Actif',
    inactive: 'Inactif',
    list: 'Liste',
  },
}


